import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=63e6a167"
import script from "./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports